module.exports = __webpack_public_path__ + "img/ic_12_down_white.066ac146.svg";